/**
 * 批量预约提货 组件
 * 勾选 多个订单 批量预约提货
 * 显示订单号及订单信息及 图片列表
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 * @param deliveryOrderId 编辑时传入此id,等同于将以有否 deliveryOrderId 判断是否编辑状态
 **/
import React from "react";
import { message,Modal} from 'antd';
import { GoogleMap, LoadScript, } from '@react-google-maps/api';
import LogisticsCompanyList from "./logisticsCompanyList/logisticsCompanyList"
import {symbolMoneyUtil,isEmpty} from '@utils/utils';
import Lang from "@components/Lang/Lang";
import StepSecondForm from './form';
import StepOne from "../stepOne/stepOne";
import './stepSecond.less'
import Locale from "@utils/locale";
import PickUpPoDrawerAction from "../pickUpPoDrawer.action";
import StepSecondType from "./stepSecondType";
import dayjs from "dayjs";
const locale = Locale.current();
export default class StepSecond extends React.Component{
    static propTypes = {
    }
    static defaultProps = {
        modelTwo:{},
        selectIds:[]
    };
    constructor(props) {
        super(props);
        this.state = {
            mapErr:false, //无法加载地图组件
            visible: false,
            edit: props.deliveryOrderId?true:false,
            pickupType: props.deliveryOrderId?props.type:"", // 提货类型
        }
    }
    /**
     * 賦值
     * **/
    onChangeType(type,data){
        let obj = this.state;
        obj[type] = data;
        this.setState(obj);
        console.log(obj,"data",data)
    }

    /*
    * 打开 查看订单
    * http://rap.essa.top:88/workspace/myWorkspace.action?projectId=211#7902  选择PO单预约提货
    * */
    openDetail(flag=false){
        if(flag){
            const { selectIds,buyerId} = this.props;
            const sUrl = "/mg/abd/whs/deliveryOrder/query-booking-delivery-po";
            const data = {
                ids: selectIds,
                id: buyerId,
            }
            PickUpPoDrawerAction.postHttpAction(sUrl,data).then((res)=>{
                const resData = res.data||{}
                // 响应结果
                let { success, valid, model} = resData;
                if (success && valid) {
                    const { selectPoList } = model||{};
                    this.setState({
                        selectPoList:selectPoList||[],
                    })
                }
            })
        }
        this.setState({
            visible: flag
        })
    }
    /**
     * 保存
     * id	预约提货单id	number	新增为空 编辑不为空
     * type	提货方式	string	10:个人自提 20:第三方公司 30:配送
     *
     * poIds 预约提货的 POId	array<number>
     * preDeliveryDate	预约提货时间	number
     *
     * contactMobile	自提-联系人电话	string
     * contactName	自提-联系人名称	string
     * contactTelCode	自提-联系人电话前缀	string
     * logisticsCompanyName	自提-物流公司名称	string
     *
     * logisticsNumber	物流单号	string
     *
     * consigneeId	配送-收货地址Id	number
     * logisticsCompanyId	配送-物流公司id	number
     * hasDeliveryService	是否需要送货服务	number
     * hasWoodenPallets	配送-是否需要打木架	number	0:不需要 1需要
     * */
    async save(){
        const {pickupType} = this.state;
        if(isEmpty(pickupType)){
            message.info(Lang({id:"NiZhunBeiRuHeTiHuo",default:"你准备如何提货"})+"?")
            return false
        }
        const data =  await this.onRefForm.save();
        if(data){
            //如果区号是+7，手机号码只能是10位数字，不能多也不能少。
            if(data.contactTelCode=="7"){
                const regSeven = /^\d{10}$/
                const passSeven = regSeven.test(data.contactMobile); //手机校验
                if(!passSeven){
                    //请填写正确的手机号码
                    message.info(__getServerLanguage("QingTianXieZhengQueDeShouJi"))
                    return false
                }
            }
            // 类型 为 30 需要 校验 收货地址和物流公司 -是否需要打木架(hasWoodenPallets配送) 必选  // 收货地址isEmpty(consigneeId)||
            const { logisticsCompanyId,hasDeliveryService,hasWoodenPallets} = data;
            if(pickupType=="30"){
                if(isEmpty(logisticsCompanyId)||isEmpty(hasWoodenPallets)){
                    message.info(Lang({id:"QingTianXieWanZhengDeBiTianXiang",default:"请填写完整的必填项"}))
                    return false
                }
            }
            const { selectIds, deliveryOrderId} = this.props;
            let reJson = {
                ...data,
                preDeliveryDate:dayjs(data.preDeliveryDate).valueOf(),//预约提货时间 无论是哪种方式都是必填项，到此走必有数据
                type:pickupType,
                poIds:selectIds,
                logisticsCompanyId,
                hasDeliveryService,
                hasWoodenPallets
            }
            if(deliveryOrderId){
                reJson["id"] = deliveryOrderId; //新增为空 编辑不为空
            }
            return reJson
        }else {
            message.info(Lang({id:"QingTianXieWanZhengDeBiTianXiang",default:"请填写完整的必填项"}))
            return false
        }
    }

    init(){
        const { modelTwo={} } = this.props;
        const {deliveryTypeList, freeDays,freeEndDate,poInfo,warehouseManageVO,woodenPalletsPrice,currencySymbol,price,logisticsCompanyList,transitCityName,
            transitCityCode,countryName,countryCode }= modelTwo;
        this.setState({
            deliveryTypeList:deliveryTypeList||[], //提货方式
            logisticsCompanyList:logisticsCompanyList||[], // 物流公司
            freeEndDate:freeEndDate||"", // 免费停仓结束日期
            poInfo:poInfo||{}, //预约PO单统计信息
            warehouseManageVO:warehouseManageVO||{},
            woodenPalletsPrice:woodenPalletsPrice||"", // 打木架费用
            currencySymbol:currencySymbol||"", //预约PO单统计信息
            price:price||0, // 停仓每日单价
            freeDays:freeDays,// 免费停仓期 天
            transitCityCode, // 中转城市编码
            transitCityName, // 中转城市名称
            countryName, // 服务国家名称
            countryCode, // 服务国家编码
        })
    }
    onRefForm = (ref) =>  this.onRefForm= ref;
    componentDidMount() {
        this.init();
        if( this.props.onRef)this.props.onRef(this);
    };
    render() {
        const { mapErr,selectPoList, pickupType,deliveryTypeList,logisticsCompanyList,visible,
            freeDays,poInfo,warehouseManageVO,woodenPalletsPrice,currencySymbol,price,
            transitCityCode, // 中转城市编码
            transitCityName,// // 中转城市名称
            countryName, // 服务国家名称
            countryCode, // 服务国家编码
            edit, //编辑状态
            } = this.state;
        const { consigneeList,modelTwo,deliveryOrderId } = this.props; // 收货地址信息
        return (<>
            <div className={"batchPickStepSecond"}>
                <div className={"flex-item-no-wrap info"}>
                    <i className={"ri-information-fill color-blue"} />
                    <div className={"ml_4"}>
                        {/* 入库后有 {0} 天免费停仓期，延期收费 {1} 元/m³/天。  */}
                        {(price&&price>0)?<p className={"black89 font_14 fw_500 line"}>{__getServerLanguage("RuKuTingCangTiShi",freeDays,
                            symbolMoneyUtil(price, currencySymbol)
                        )}</p>:null}
                        {/* 合计： 2 个订单(9 箱, 24 款) ,  体积 2.858 m³, 重量 86 kg。 */}
                        {(poInfo&&poInfo.poNum)?<p className={"mt_8 font_12"}>
                            {__getServerLanguage("HeJi")}： {__getServerLanguage("NGeDingDan",poInfo.poNum)}({__getServerLanguage('NKuanNXiang',poInfo.totalCount,poInfo.totalQuantity)}) ,
                            {__getServerLanguage("TiJiNZhongLiangN",poInfo.totalVolume+" m³",poInfo.totalGrossWeight+" kg")}。
                        </p>:null}
                        {/* 查看订单 */}
                        <span className={"color-blue font_12 cursor-p"} onClick={()=>this.openDetail(true)}>{__getServerLanguage("ChaKanDingDan")}</span>
                    </div>
                </div>
                {/* 你准备如何提货 */}
                <p className={"mt_16 fw_700 black89 mb_8"}><span className={"color-danger mr_2"}>*</span>
                    {Lang({id:"NiZhunBeiRuHeTiHuo",default:"你准备如何提货"})}?
                </p>
                {/*{deliveryTypeList&&deliveryTypeList.length>0?<div className={"flex-item typeWrap"}>*/}
                        {/*{deliveryTypeList.map((typeObj,inx)=>this.renderType("pickupType",typeObj.type,pickupType,typeObj.name,typeObj.icon))}*/}
                {/*</div>:null}*/}
                {deliveryTypeList&&deliveryTypeList.length>0&&<StepSecondType list={deliveryTypeList}
                                                                              noClick={edit} // 默认可点击，编辑时不以点击
                                                                              onChangeType={(value)=>this.onChangeType("pickupType",value)}
                                                                              pickupType={pickupType} />}
                {/* 选择方式后显示表单*/}
               {pickupType&&pickupType>0?<StepSecondForm type={pickupType} onRef={this.onRefForm}
                                                         deliveryOrderId={deliveryOrderId}
                                                         reLoadTwo={(callBack)=>this.props.reLoadTwo(callBack)}// 刷新数据，主要是新增地址后刷新数据
                                                         consigneeList={consigneeList}
                                                         woodenPalletsPriceAndSymbol={symbolMoneyUtil(woodenPalletsPrice, currencySymbol)}
                                                         warehouseManageVO={warehouseManageVO}
                                                         logisticsCompanyList={logisticsCompanyList}
                                                         transitCityCode={transitCityCode} // 中转城市编码
                                                         transitCityName={transitCityName} // 接收城市
                                                         currencySymbol={currencySymbol}
                                                         countryName={countryName}// 服务国家名称
                                                         countryCode={countryCode}  // 服务国家编码
                                                         fromInitialValues={modelTwo} //入参信息
               />:<div className={"commonWrap"}>
                   <p className={"mb_4 black89"}>{Lang({id:"WoMenHeZuoDeWuLiuGongSiYou",default:"我们合作的物流公司有"})}</p>
                   {/*<LogisticsCompanyList logisticsCompanyList={logisticsCompanyList} />*/}
                   {logisticsCompanyList&&logisticsCompanyList.length>0&&<LogisticsCompanyList logisticsCompanyList={logisticsCompanyList}
                                                                                               countryName={countryName}// 服务国家名称
                                                                                               countryCode={countryCode}  // 服务国家编码
                                                                                               transitCityName={transitCityName} // 接收城市
                                                                                               showRecommend={false} // 不显示推荐物流
                                                                                               isRecommendOneTips={true} // 显示第一个推荐物流数据提示
                   />}
               </div>}
                {/* 地图 */}
                {/* ESSAONE 仓库地址 */}
                {pickupType&&warehouseManageVO&&<div className={"mapWrap"}>
                    <div className={"fixInfo"}>
                        <p className={"fw_700 font_16"}>
                            {warehouseManageVO.transitCityName&&<span className={"mr_2"}>{warehouseManageVO.transitCityName}</span>}
                            {Lang({id:"CangKu",default:"仓库"})}
                        </p>
                        <p className={"mt_8"}>{warehouseManageVO.addrLandCode?__getServerLanguage(warehouseManageVO.addrLandCode):""}</p>
                        <p>{warehouseManageVO.name}</p>
                        <p>+{warehouseManageVO.telCode} {warehouseManageVO.mobile}</p>
                        <p className={"color-orange mt_8"}>
                            {Lang({id:"GongZuoShiJian",default:"工作时间"})}
                            <span className={"ml_4"}>{warehouseManageVO.workStartTime} - {warehouseManageVO.workEndTime}</span>
                        </p>
                    </div>
                    {/* 地图 */}
                    {warehouseManageVO.latitude&&warehouseManageVO.longitude&&<LoadScript
                        googleMapsApiKey="AIzaSyCu7Z-LKqvO6fL8WIpnDhuFTtrJD7L_1cg"
                        language={locale||"ru"}
                        loadingElement={<div className={"text-center tips"}>{mapErr?Lang({id:"WuFaJiaZaiDiTuZuJian",default:"无法加载地图组件"}):Lang({id:"ZhengZaiChuLiQingShaoHou",default:"正在加载中…"})}</div>}
                        onError={()=>this.setState({mapErr:true})}
                    >
                        <GoogleMap
                            mapContainerStyle={{
                                width: '650px',
                                height: '411px'
                            }}
                            center={{
                                lat: warehouseManageVO.latitude,
                                lng: warehouseManageVO.longitude
                            }}
                            zoom={10}
                        >
                            { /* Child components, such as markers, info windows, etc. */ }
                            <></>
                        </GoogleMap>
                    </LoadScript>}
                </div>}
                <Modal open={visible}
                       width={660}
                       footer={null}
                       onCancel={()=>this.openDetail()}>
                    <StepOne inStoragePoList={selectPoList} type={2} selectObj={{}} />
                </Modal>
            </div>
        </>);
    }
}

